import { NetworkInfo, Product } from "@alch/dx-entities";

export const isBlastOnlyNetwork = (networkInfo: NetworkInfo) => {
  return (
    networkInfo.supportedProducts.includes(Product.Blast) &&
    !networkInfo.supportedProducts.includes(Product.NodeApi)
  );
};

export const excludeBlastOnlyNetworks = (networkInfo: NetworkInfo) => {
  return !isBlastOnlyNetwork(networkInfo);
};
